module.exports = __webpack_public_path__ + "img/create-free-account.26e88a3c.svg";